module.exports = __webpack_public_path__ + "static/media/mozart-child.1646a859.jpg";